import { render, staticRenderFns } from "./RequiresLti.vue?vue&type=template&id=dec7bcd4&scoped=true"
import script from "./RequiresLti.vue?vue&type=script&lang=js"
export * from "./RequiresLti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec7bcd4",
  null
  
)

export default component.exports